import { type ReactNode, useRef } from "react";
import { useButton } from "react-aria";

//@ts-ignore
import styles from "ui-kit/src/ButtonComponent/Button.module.scss";

interface ButtonProps {
	className?: string;
	children?: ReactNode;
	onPress?: () => void;
	disabled?: boolean | undefined;
	loading?: boolean | undefined;
	size?: "sm" | "lg" | undefined;
	variant?: "primary" | "secondary" | undefined;
	type?: "submit" | "reset" | "button" | undefined;
	block?: boolean | undefined;
	icon?: string | undefined;
}

export default function Button(props: ButtonProps) {
	const ref = useRef(null);

	const { buttonProps } = useButton(props, ref);
	const { children, className, size, variant, block, loading } = props;

	const classNames = [styles["ui-kit-btn"]];

	if (size) {
		classNames.push(styles[`ui-kit-btn-${size}`]);
	}
	if (variant) {
		classNames.push(styles[`ui-kit-btn-${variant}`]);
	}
	if (block) {
		classNames.push(styles["ui-kit-btn-block"]);
	}
	if (loading) {
		classNames.push(styles["ui-kit-is-loading"]);
	}
	if (className) {
		classNames.push(className);
	}

	return (
		<button {...buttonProps} ref={ref} className={`${classNames.join(" ")}`} type={props.type} disabled={props?.disabled}>
			{props.icon && <span className={`${styles["ui-kit-btn-icon"]} ${props.icon}`} />}
			{children}
		</button>
	);
}
